
const DiagonalHatch = () => (
  <pattern id="diagonalHatch" width="4" height="4" patternUnits="userSpaceOnUse">
    <path d="M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2" stroke="black" strokeWidth="1" opacity="0.15" />
  </pattern>
);

export default DiagonalHatch;
